<template>
	<div class="color-selector outer" :class="{ active: active }">
		<div class="inner" :style="{ backgroundColor: color }"></div>
	</div>
</template>
<script>
export default {
	props: {
		color: {
			type: String,
			default: '#ffffff'
		},
		active: {
			type: Boolean,
			default: false
		}
	}
};
</script>
<style lang="scss" scoped>
.outer {
	height: 32px;
	width: 32px;
	border-radius: 32px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	border: 2px solid #dfe9f4;

	@media (min-width: $breakpoint-mid) {
		height: 48px;
		width: 48px;
		border-radius: 48px;
	}

	@media (min-width: $breakpoint-max) {
		height: 64px;
		width: 64px;
		border-radius: 64px;
	}

	.inner {
		height: 20px;
		width: 20px;
		border-radius: 20px;

		@media (min-width: $breakpoint-mid) {
			height: 30px;
			width: 30px;
			border-radius: 30px;
		}

		@media (min-width: $breakpoint-max) {
			height: 40px;
			width: 40px;
			border-radius: 40px;
		}
	}

	&.active {
		border-color: $primary-state;
	}

	@media (any-hover: hover) {
		&:hover {
			border-color: $hover-state;
			cursor: pointer;
		}
	}

	&:active {
		border-color: $tapped-state;
	}
}
</style>
